import { Component, OnInit, Output, EventEmitter, Input, OnChanges, SimpleChanges, AfterViewInit, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { ReportService } from '@app/_components/report';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { first } from 'rxjs/operators';
import { MatMenuItem as MatMenuItem } from '@angular/material/menu';
import { RateBucketService } from '@app/_components/rate/rate-bucket';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConstantService } from '@app/_services';

@Component({
    selector: 'app-search-guest-template',
    templateUrl: './guest-search-template.component.html',
    styleUrls: ['./guest-search-template.component.css'],
    standalone: false
})
export class GuestSearchTemplateComponent implements OnInit, OnChanges, AfterViewInit {

	@Output() doSearchCB = new EventEmitter<any>();
	@Input() reset: boolean;
	@Input() searchLabel: string;
	@Input() formTitle: string;
	@Input() showReservationStatus: boolean;

	@Input() showDevelopments: boolean;
	@Input() showBedrooms: boolean;
	@Input() showShortTermRentals: boolean;

	@Input() showCheckInDateRange: boolean;
	@Input() showCheckOutDateRange: boolean;
	@Input() showAdults: boolean;
	@Input() showChilds: boolean;

	selectedShortTermRentalIds: any = [];
	selectedDevelopmentIds: any = [];
	selectedBedrooms: any = [];
	selectedDateCheckIn: any;
	selectedDateCheckOut: any;

	selectedFormReservationStatus: any;
	selectedFormAdults: any;
	selectedFormChilds: any;
	shortTermRentals: any;
	developments: any;

	bedrooms = [
		{ id: 1, name: 'Studio/1Bd' },
		{ id: 2, name: '2 Bd' },
		{ id: 3, name: '3 Bd' },
		{ id: 4, name: '4 Bd' },
		{ id: 5, name: '5 Bd' },
		{ id: 6, name: '6 Bd' },
		{ id: 7, name: '7 Bd' },
		{ id: 8, name: '8 Bd' },
		{ id: 9, name: '9 Bd' },
		{ id: 10, name: '10 Bd' },
	];

	adultsChilds = [
		{ id: 1, name: '1' },
		{ id: 2, name: '2' },
		{ id: 3, name: '3' },
		{ id: 4, name: '4' },
		{ id: 5, name: '5' },
		{ id: 6, name: '6' },
		{ id: 7, name: '7' },
		{ id: 8, name: '8' },
		{ id: 9, name: '9' },
		{ id: 10, name: '10' },
	]

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formToSubmit: any;

	constructor(private reportService: ReportService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private rateBucketService: RateBucketService,
		public formBuilder: UntypedFormBuilder,
		public constantService: ConstantService,
		private dialog: MatDialog,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.searchLabel = data.searchLabel,
			this.formTitle = data.formTitle,
			this.showReservationStatus = data.showReservationStatus;
		this.showDevelopments = data.showDevelopments;
		this.showBedrooms = data.showBedrooms;
		this.showCheckInDateRange = data.showCheckInDateRange;
		this.showCheckOutDateRange = data.showCheckOutDateRange;
		this.showAdults = data.showAdults;
		this.showChilds = data.showChilds;
		this.showShortTermRentals = data.showShortTermRentals;
	}

	ngAfterViewInit(): void {
	}


	ngOnInit(): void {
		this.loadShortTermRentals();
		this.loadDevelopments();
		this.formBuild();

		// clear the presets, if any.
		if (this.reset) {
			this.form1.reset();
		}
	}

	ngOnChanges(changes: SimpleChanges): void {

	}

	/*
	 *
	 *SEARCH FORM - TO PUT INTO COMPONENT
	 *
	 */
	searchClick() {
		console.log(this.form1.value);
		this.buildSearchForm();
		console.log(JSON.stringify(this.formToSubmit));
		this.doSearchCB.emit(this.formToSubmit);
		return;
	}


	formBuild() {

		this.form1 = this.formBuilder.group({
			formReservationStatus: [],
			formShortTermRentalIds: [],
			formDevelopmentIds: [],
			formBedrooms: [],
			formCheckInDateRange: [],
			formCheckOutDateRange: [],
			formChildrensCount: [],
			formAdultsCount: [],
		});
	}

	/**
	 * Build a Search Form
	 */
	buildSearchForm() {
		this.formToSubmit = {};
		
		// developmentIds
		this.selectedDevelopmentIds = [];
		if (this.form1.get('formDevelopmentIds').value) {
			this.form1.get('formDevelopmentIds').value.forEach(element => {
				this.selectedDevelopmentIds.push(element.developmentId);
			});
			this.formToSubmit.developmentIdList =  this.selectedDevelopmentIds;
		}

		// shortTermRentalIds
		this.selectedShortTermRentalIds = [];
		if (this.form1.get('formShortTermRentalIds').value) {

			this.form1.get('formShortTermRentalIds').value.forEach(element => {
				this.selectedShortTermRentalIds.push(element.shortTermRentalId);
			});
			this.formToSubmit.shortTermRentalIdList =  this.selectedShortTermRentalIds;
		}

		// bedrooms
		this.selectedBedrooms = [];
		if (this.form1.get('formBedrooms').value) {
			this.form1.get('formBedrooms').value.forEach(element => {
				this.selectedBedrooms.push(element.id);
			});
			// this.formToSubmit.shortTermRentalVO.bedrooms = this.selectedBedrooms;
			this.formToSubmit.bedroomList =  this.selectedBedrooms;
		}

		// CheckIn start/end date
		if (this.form1.get('formCheckInDateRange').value) {
			this.selectedDateCheckIn = this.form1.get('formCheckInDateRange').value;
			this.formToSubmit.startDate =  this.selectedDateCheckIn;
		}

		// CheckOut start/end date
		if (this.form1.get('formCheckOutDateRange').value) {
			this.selectedDateCheckOut = this.form1.get('formCheckOutDateRange').value;
			this.formToSubmit.endDate =  this.selectedDateCheckOut;
		}

		this.selectedFormReservationStatus = [];
		if (this.form1.get('formReservationStatus').value) {
			this.form1.get('formReservationStatus').value.forEach(element => {
				this.selectedFormReservationStatus.push(element.value);
			});
			this.formToSubmit.reservationStatusList =  this.selectedFormReservationStatus;
		}

		this.selectedFormAdults = [];
		if (this.form1.get('formAdultsCount').value) {
			this.form1.get('formAdultsCount').value.forEach(element => {
				this.selectedFormAdults.push(element.id);
			});
			this.formToSubmit.adultsList =  this.selectedFormAdults;
		}

		this.selectedFormChilds = [];
		if (this.form1.get('formChildrensCount').value) {
			this.form1.get('formChildrensCount').value.forEach(element => {
				this.selectedFormChilds.push(element.id);
			});
			this.formToSubmit.childsList =  this.selectedFormChilds;
		}
	}

	loadShortTermRentals() {
		this.formLoading = true;
		this.reportService.propertySummaryList().pipe(first()).subscribe(

			data => {
				this.shortTermRentals = data.data.propertySummaryList;
			},
			error => {
				console.log('reports LIST!: ' + JSON.stringify(error));
				this.messageService.add({ severity: 'error', summary: error.message, life: 3000 });
			},
			() => { this.formLoading = false; }
		);
	}

	loadDevelopments() {
		this.formLoading = true;
		this.reportService.developmentSummaryList().pipe(first()).subscribe(

			data => {
				this.developments = data.data.developmentSummaryList;
			},
			error => {
				console.log('reports LIST!: ' + JSON.stringify(error));
				this.messageService.add({ severity: 'error', summary: error.message, life: 3000 });
			},
			() => { this.formLoading = false; }
		);
	}

	getResStatusName(resStatus) {
		return this.constantService.reservationStatuses.find(function (item) { return item.value === resStatus }).label;
	}

	getResStatusColor(resStatus) {
		return this.constantService.reservationStatuses.find(function (item) { return item.value === resStatus }).color;
	}

}
